// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__7S3si","inner":"Dashboard_inner__eFuOT"};